export default __webpack_public_path__ + "static/media/notEmergencyContact.9e2b9b4a.svg";